export default {
  methods: {
    allowZeroPrice () {
      return false
    }
  },
  computed: {
    price: {
      get () {
        if (this.allowZeroPrice()) {
          return this.$options.filters.priceFromCentZero(this.getPrice())
        }
        return this.$options.filters.priceFromCent(this.getPrice())
      },
      set (val) {
        const price = parseInt(parseFloat(val.replace(',', '.') * 100).toFixed(2))
        this.setPrice(price)
      }
    }
  }
}
